import {
  ChangeInstalledStockItem,
  ChangeStockItemModel,
  InstalledStockItem,
  InstalledStockItemsQuery,
  InstalledStockItemsStats
} from "../../inventory/models/models";
import { Page } from "../../../shared/models/models";
import api from "../../../core/api";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.inventoryApiBaseUrl };
}

class CustomerInstalledStockItemApi {
  getInstalledStockItems(query: InstalledStockItemsQuery): Promise<InstalledStockItem[]> {
    return api.get<InstalledStockItem[]>(
      `/v1/supplier/installed-stock-items`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getMachineStockItemStats(machineId: string): Promise<InstalledStockItemsStats> {
    return api.get<InstalledStockItemsStats>(
      `/v1/supplier/installed-stock-items/machine/${machineId}`, { ...getRequestConfig() })
      .then(x => x.data);
  }

  installStockItems(machineId: string, model: ChangeInstalledStockItem[]): Promise<any> {
    return api.put(`/v1/supplier/installed-stock-items/machine/${machineId}`, model, getRequestConfig())
      .then(x => x.data);
  }

  unlinkStockItems(machineId: string, model: string[]): Promise<any> {
    return api.post(`/v1/supplier/installed-stock-items/machine/${machineId}`, model, getRequestConfig())
      .then(x => x.data);
  }
}

export default new CustomerInstalledStockItemApi;
